/**
 * A password the wizard can offer instead of asking the operator to invent one.
 *
 * Fourteen characters from an alphabet with the look-alikes taken out (no
 * 0/O, no 1/l/I): this password is READ OUT over the phone and typed off a
 * printout at least once, and a character the reader cannot tell from its
 * neighbour is a sign-in that fails on the first try. Fifty-seven symbols to
 * the fourteenth power is far past anything a login rate limit lets anyone
 * attempt.
 */
const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';

export const GENERATED_PASSWORD_LENGTH = 14;

export function generatePassword(
  length = GENERATED_PASSWORD_LENGTH,
  random: (n: number) => Uint32Array = (n) => crypto.getRandomValues(new Uint32Array(n)),
): string {
  const values = random(length);
  let out = '';
  for (let i = 0; i < length; i += 1) out += ALPHABET[values[i]! % ALPHABET.length];
  return out;
}

/** Whether a string could only have come from `generatePassword`'s alphabet — for the tests. */
export function isFromGeneratorAlphabet(value: string): boolean {
  return value.length > 0 && [...value].every((c) => ALPHABET.includes(c));
}
